theme.footerSection = (function(){
  function footer(){
    let accordion = true
    const footerWidgetAccordion = function () {
      accordion = false
      document.querySelectorAll(".footer__widget_toggle").forEach(function (item) {
        item.addEventListener('click', function () {
          const footerWidget = this.closest('.footer__widget'),
                footerWidgetInner = footerWidget.querySelector('.footer__widget_inner')
          if(footerWidget.classList.contains('active')) {
            footerWidget.classList.remove('active')
            slideUp(footerWidgetInner)
          } else {
            footerWidget.classList.add('active')
            slideDown(footerWidgetInner)
            getSiblings(footerWidget.parentElement).forEach(function (item) {
              const footerWidget = item.querySelector('.footer__widget'),
                    footerWidgetInner = item.querySelector('.footer__widget_inner')
              if (footerWidget && !footerWidget.classList.contains('footer__widget--always-visible')) {
                footerWidget.classList.remove('active')
                slideUp(footerWidgetInner)
              }
            })

          }
        })
      })
    }

    // Open default widgets on mobile
    if (window.outerWidth < 768) {
      document.querySelectorAll('.footer__widget--open-default').forEach(function (item) {
        item.classList.add('active')
        var inner = item.querySelector('.footer__widget_inner')
        if (inner) inner.style.display = 'block'
      })
    }

    if(accordion){
      footerWidgetAccordion();
    }
    window.addEventListener('resize', function () {
      document.querySelectorAll('.footer__widget').forEach(function (item) {
        if(window.outerWidth >= 768) {
          item.classList.remove('active')
          item.querySelector('.footer__widget_inner').style.display = ''
        }
      })
      if(accordion) {footerWidgetAccordion()}
    })
  }
  return footer;
})();
